/**
 * Unified WorkBuffer 到当前 Three GSplat raster shader API 的桥接层。
 *
 * 数据声明与 get* 解码逻辑来自当前 GSplatFormat，read* 入口则保留现有 raster shader
 * 的调用约定。这样 compact/large 的布局选择不再退回旧 transformA/transformB/splatColor。
 */
export default /* glsl */ `
uniform highp uint splatTextureSize;

struct Splat {
  uint index;
  ivec2 uv;
};

Splat splat;

#include "gsplatCovarianceVS"
#include "gsplatDeclarationsVS"
#include "gsplatReadVS"

void selectUnifiedSplat(in SplatSource source) {
  splat.index = source.id;
  splat.uv = source.uv;
}

vec3 readCenter(SplatSource source) {
  selectUnifiedSplat(source);
  return getCenter();
}

void readCovariance(in SplatSource source, out vec3 covA, out vec3 covB) {
  selectUnifiedSplat(source);
  vec4 rotation = getRotation();
  vec3 scale = getScale();
  computeCovariance(quatToMat3(rotation), scale, covA, covB);
}

vec4 readColor(in SplatSource source) {
  selectUnifiedSplat(source);
  float opacity = getOpacity();
  vec3 color = getColor();
  return vec4(color, opacity);
}
`
